import { Routes } from '@angular/router';
import { NewsComponent } from './news.component';
import { AuthGuardService } from '../guards/auth-guard.service';

export const newsRoutes: Routes = [
  {
    path: 'news',
    component: NewsComponent,
    canActivate: [ AuthGuardService ],
  }
];



// WEBPACK FOOTER //
// ./src/app/news/news.routes.ts